import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-confirmed-feedback',
  imports: [MatCardModule],
  templateUrl: './confirmed-feedback.component.html',
  styleUrl: './confirmed-feedback.component.scss',
})
export class ConfirmedFeedbackComponent {}
